import { useState } from 'react'
import { useRouter } from 'next/router'
import useSWR from 'swr'

import Loading from '../components/Loading'
import Layout from '../components/Layout'
import ProductsGrid from '../components/ProductsGrid'

const filterOptions = [
  { label: 'Bedroom', value: 'bedroom' },
  { label: 'Bathroom', value: 'bathroom' },
  { label: 'Kitchen', value: 'kitchen' },
  { label: 'Room Decor', value: 'room-decor' },
  { label: 'Laundry', value: 'laundry' },
  { label: 'Cleaning PPE', value: 'cleaning-ppe' },
  { label: 'Electricals', value: 'electricals' },
  { label: 'Storage', value: 'storage' },
  { label: 'Food', value: 'food' },
  { label: 'ECO by UKO', value: 'eco' },
  { label: 'Stationary', value: 'stationary' },
];

export default function Home() {

  // We're swapping elements in the extras array, to manually set in the "bestselling" order for Unite specifically 
  const swapElements = (array, index1, index2) => {
    let temp = array[index1];
    array[index1] = array[index2];
    array[index2] = temp;
  };


  const router = useRouter()
  const [filter, setFilter] = useState("");
  const { data: extras } = useSWR('/api/extras')

  if (!extras) return <Loading />

  console.log('EXTRAS ONE - ', extras)
  swapElements(extras, 0, 20)
  swapElements(extras, 1, 3)
  swapElements(extras, 3, 2)
  swapElements(extras, 2, 37)
  swapElements(extras, 4, 18)
  swapElements(extras, 5, 12)
  swapElements(extras, 6, 36)
  swapElements(extras, 7, 32)
  swapElements(extras, 8, 74)
  swapElements(extras, 9, 76) 

  const filteredExtras = extras.filter(extra => {
    if (!filter) return true;
    const extraFilters = extra.filter.split(",");
    return extraFilters.includes(filter.toLowerCase());
  });

  const itemAddedToCart = router.query?.itemAddedToCart


console.log('EXTRAS TWO - ', extras)

swapElements(extras, 0, 20)
swapElements(extras, 1, 3)
swapElements(extras, 3, 2)
swapElements(extras, 2, 37)
swapElements(extras, 4, 18)
swapElements(extras, 5, 12)
swapElements(extras, 6, 36)
swapElements(extras, 7, 32)
swapElements(extras, 8, 74)
swapElements(extras, 9, 76) 
extras.splice(101, 1)
extras.splice(83, 1)



  return (
    <Layout>
      <div className="-mt-4 pb-4">
        {itemAddedToCart && <div className="pt-2 pb-10">
          <h2 className="py-2 text-3xl font-bold">Now add your extras</h2>
          <p className="font-light">For all those things you forgot you needed</p>
        </div>}
        <div className="sm:hidden">
          <label htmlFor="filter-tabs" className="sr-only">Select a filter</label>
          <select value={filter} onChange={e => setFilter(e.target.value)} id="filter-tabs" name="filter-tabs" className="block w-full focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md" style={{padding: '10px', borderRadius: '15px'}}>
            <option value="">All Items</option>
            {filterOptions.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
          </select>
        </div>
        <div className="hidden sm:block extras-filters-container">
          <nav className="flex gap-x-4 flex-wrap" aria-label="Tabs" style={{columnGap: '0.6rem'}}>
            <button onClick={() => setFilter('')} type="button" className={`${filter === '' ? 'bg-primary/70 text-black filter-button--selected' : 'text-gray-500 hover:text-gray-700'} px-3 py-2 font-medium text-sm rounded-md filter-button`}>All</button>
            {filterOptions.map(option => <button key={option.value} onClick={() => setFilter(option.value)} type="button" className={`${filter === option.value ? 'bg-primary/70 text-black filter-button--selected' : 'text-gray-500 hover:text-gray-700'} px-3 py-2 font-medium text-sm rounded-md filter-button`} style={{fontWeight: 700}}>{option.label}</button>)}
          </nav>
        </div>
      </div>

      <ProductsGrid products={filteredExtras} />
    </Layout>
  )
}